/**
 * Compatibility entrypoint (BKPE-27795).
 *
 * The shared logger now lives under `features/observability/logger`. This shim
 * re-exports the same module bindings — including the singleton `logger`,
 * shared logging context, and early-log buffer — so existing `utils/logger`
 * imports keep resolving without creating a second logger instance.
 */
export * from 'features/observability/logger';
export { default } from 'features/observability/logger';
